import React from 'react';

import {useTranslation} from 'react-i18next';
import {Form} from 'react-bootstrap';

interface IGenderInputProps {
    name: string;
    className?: string;
    defaultValue?: string;
    inputRef?: React.Ref<HTMLSelectElement>;
    onBlur?: () => void
    onChange?: (value: string) => void
    isInvalid?: boolean;
    disabled?: boolean;
    size?: 'sm' | 'lg';
}

export const GenderInput = (
    {name, defaultValue, inputRef, className, onBlur, onChange, isInvalid, disabled, size}: IGenderInputProps
) => {
    const {t} = useTranslation();

    return (
        <Form.Control
            custom
            as="select"
            className={className}
            defaultValue={defaultValue}
            name={name}
            ref={inputRef}
            isInvalid={isInvalid}
            onBlur={onBlur}
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.value)}
            size={size}
        >
            <option value="">
                {t('common.select', 'Select')}
            </option>
            <option value="MALE">
                {t('gender.male', 'Male')}
            </option>
            <option value="FEMALE">
                {t('gender.female', 'Female')}
            </option>
            <option value="NOT_SPECIFIED">
                {t('gender.notSpecified', 'Not Specified')}
            </option>
            <option value="PREFER_NOT_TO_SAY">
                {t('gender.preferNotToSay', 'Prefer Not to Say')}
            </option>
            <option value="OTHER">
                {t('gender.other', 'Other')}
            </option>
        </Form.Control>
    );
};
